
import { tryFind, FSharpMap__ContainsKey, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { length, singleton, ofArray, append, head, tail, isEmpty, empty, filter, sortBy, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createObj, compare, structuralHash, equals, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FSharpSet__Add, FSharpSet__Remove, empty as empty_1, FSharpSet__Contains, ofList as ofList_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_2, singleton as singleton_1, collect, append as append_1, delay, unfold, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { Button } from "../../Components/Button.js";
import Shipment_Add from "../../../public/assets/icons/Shipment_Add.svg";
import { InformationAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { withoutOnboardingTourQueryParams, isBusinessUnitsTourOverviewPhase } from "../../Common.js";
import { TourGuideLocale, TourStep, TourGuide } from "../../Components/TourGuide.js";
import { Skeleton } from "../../Components/Skeleton.js";

function buildIndex(items) {
    const byId = ofList(map((x) => [x.Id, x], items), {
        Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
    });
    const byParent = ofList(List_groupBy((x_2) => x_2.ParentId, items, {
        Equals: equals,
        GetHashCode: (x_3) => (structuralHash(x_3) | 0),
    }), {
        Compare: (x_4, y_2) => (compare(x_4, y_2) | 0),
    });
    return [sortBy((x_6) => x_6.Name, filter((x_5) => {
        const matchValue = x_5.ParentId;
        if (matchValue != null) {
            return !FSharpMap__ContainsKey(byId, matchValue);
        }
        else {
            return true;
        }
    }, items), {
        Compare: (x_7, y_3) => (comparePrimitives(x_7, y_3) | 0),
    }), (id) => sortBy((x_8) => x_8.Name, defaultArg(tryFind(id, byParent), empty()), {
        Compare: (x_9, y_4) => (comparePrimitives(x_9, y_4) | 0),
    })];
}

function BusinessUnitTreeView(props) {
    let elems_9, elems_4, elems_8, elems_6, elems_5, elems_7;
    const t = useTranslation()[0];
    const allIds = ofList_1(map((bu) => bu.Id, props.BusinessUnits), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const patternInput_1 = reactApi.useState(allIds);
    const setExpandedIds = patternInput_1[1];
    const expandedIds = patternInput_1[0];
    const patternInput_2 = buildIndex(props.BusinessUnits);
    const flatRows = toList(unfold((stack) => {
        if (!isEmpty(stack)) {
            const rest = tail(stack);
            const item = head(stack)[0];
            const depth = head(stack)[1] | 0;
            const children = patternInput_2[1](item.Id);
            return [[item, depth, children], (!isEmpty(children) && FSharpSet__Contains(expandedIds, item.Id)) ? append(map((c) => [c, depth + 1], children), rest) : rest];
        }
        else {
            return undefined;
        }
    }, map((r) => [r, 0], patternInput_2[0])));
    return reactElement("div", createObj(singleton((elems_9 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "mb-3"])], (elems_4 = [reactElement("button", {
        className: join(" ", ["text-sm", "font-semibold", "flex", "items-center", "gap-1.5", "px-3", "py-1.5", "hover:bg-background", "rounded-lg", "transition-colors", "text-text-muted"]),
        onClick: (_arg_1) => {
            setExpandedIds(ofList_1(map((bu_1) => bu_1.Id, props.BusinessUnits), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            }));
        },
        children: t("category.expand_all"),
    }), reactElement("button", {
        className: join(" ", ["text-sm", "font-semibold", "flex", "items-center", "gap-1.5", "px-3", "py-1.5", "hover:bg-background", "rounded-lg", "transition-colors", "text-text-muted"]),
        onClick: (_arg_2) => {
            setExpandedIds(empty_1({
                Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
            }));
        },
        children: t("category.collapse_all"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("table", createObj(ofArray([["className", join(" ", ["w-full", "border-collapse", "text-left", "bg-white"])], (elems_8 = [reactElement("thead", createObj(singleton((elems_6 = [reactElement("tr", createObj(ofArray([["className", join(" ", ["bg-white"])], (elems_5 = [reactElement("th", {
        className: join(" ", ["py-2.5", "px-4", "text-sm", "font-semibold", "text-left", "border-b", "border-border"]),
        children: t("general.name"),
    }), reactElement("th", {
        className: join(" ", ["py-2.5", "px-4", "text-sm", "font-semibold", "text-left", "border-b", "border-border"]),
        children: t("general.description"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])))), reactElement("tbody", createObj(singleton((elems_7 = map((tupledArg) => {
        let elems_3, elems_2, elems_1;
        const item_1 = tupledArg[0];
        const children_1 = tupledArg[2];
        const hasChildren = !isEmpty(children_1);
        const isExpanded = FSharpSet__Contains(expandedIds, item_1.Id);
        return reactElement("tr", createObj(ofArray([["key", item_1.Id], ["className", join(" ", ["group", "hover:bg-[#F2F4FD]", "transition-colors", "cursor-pointer"])], ["onClick", (_arg) => {
            RouterModule_nav(ofArray(["business-units", item_1.Id]), 1, 1);
        }], (elems_3 = [reactElement("td", createObj(ofArray([["className", join(" ", ["py-2.5", "px-4", "border-b", "border-border"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-1"])], (elems_1 = toList(delay(() => append_1(collect((matchValue) => singleton_1(reactElement("div", {
            className: join(" ", ["w-7", "flex-shrink-0"]),
        })), rangeDouble(0, 1, tupledArg[1] - 1)), delay(() => {
            let elems;
            return append_1(hasChildren ? singleton_1(reactElement("button", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center", "w-6", "h-6", "rounded", "hover:bg-background", "transition-colors", "text-text-muted", "flex-shrink-0"])], ["onClick", (e) => {
                e.stopPropagation();
                const id = item_1.Id;
                if (FSharpSet__Contains(expandedIds, id)) {
                    setExpandedIds(FSharpSet__Remove(expandedIds, id));
                }
                else {
                    setExpandedIds(FSharpSet__Add(expandedIds, id));
                }
            }], (elems = [reactElement("span", {
                className: join(" ", toList(delay(() => append_1(singleton_1("text-[10px]"), delay(() => append_1(singleton_1("inline-block"), delay(() => append_1(singleton_1("transition-transform"), delay(() => append_1(singleton_1("duration-200"), delay(() => (isExpanded ? singleton_1("rotate-90") : singleton_1(""))))))))))))),
                children: "▶",
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton_1(reactElement("span", {
                className: join(" ", ["w-6", "flex-shrink-0"]),
            })), delay(() => append_1(singleton_1(reactElement("span", {
                className: join(" ", ["text-sm", "ml-1"]),
                children: item_1.Name,
            })), delay(() => (hasChildren ? singleton_1(reactElement("span", {
                className: join(" ", ["text-xs", "text-text-muted", "ml-1.5"]),
                children: `(${length(children_1)})`,
            })) : empty_2())))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("td", {
            className: join(" ", ["py-2.5", "px-4", "border-b", "border-border", "text-sm", "text-text-muted"]),
            children: item_1.Description,
        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    }, flatRows), ["children", reactApi.Children.toArray(Array.from(elems_7))]))))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))]))));
}

function BusinessUnitsOverviewTable(props) {
    let elems_1, elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-end", "mb-3"])], (elems = toList(delay(() => {
        let Label;
        if (isEmpty(props.CurrentUser.BusinessUnitIds)) {
            const matchValue = props.UserData.Role;
            switch (matchValue) {
                case "toolManager":
                case "user": {
                    return empty_2();
                }
                default:
                    return singleton_1(createElement(Button, (Label = patternInput[0]("business_units.overview.create_new_business_unit"), {
                        ComponentState: "enabled",
                        Icon: Shipment_Add(),
                        Label: Label,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["business-units", "new"]), 1, 1);
                        },
                        TestId: "add-new-business-units-button",
                        Variant: "primary",
                    })));
            }
        }
        else {
            return empty_2();
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(BusinessUnitTreeView, {
        BusinessUnits: props.BusinessUnits,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function BusinessUnitsOverview(props) {
    let elems_1;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_1 = toList(delay(() => {
        let elems;
        return props.AccountSettings.BusinessUnitsEnabled ? singleton_1(createElement(BusinessUnitsOverviewTable, {
            BusinessUnits: props.BusinessUnits,
            CurrentUser: props.CurrentUser,
            Dispatch: props.Dispatch,
            UserData: props.UserData,
        })) : singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["w-10/12"])], (elems = [createElement(InformationAlert, {
            Label: "business_units.overview.not_included",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function OverviewView(props) {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const t = useTranslation()[0];
    const patternInput_2 = reactApi.useState(false);
    const setBusinessUnitsTourOverviewDismissed = patternInput_2[1];
    let canShowCreateBusinessUnitButton;
    const matchValue = props.UserData.Role;
    switch (matchValue) {
        case "toolManager":
        case "user": {
            canShowCreateBusinessUnitButton = false;
            break;
        }
        default:
            canShowCreateBusinessUnitButton = isEmpty(props.CurrentUser.BusinessUnitIds);
    }
    const matchValue_1 = state_1.BusinessUnits;
    const matchValue_2 = state_1.AccountSettings;
    let matchResult, accountSettings, businessUnits;
    if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_2.fields[0];
        businessUnits = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0: {
            const showBusinessUnitsOverviewTour = ((isBusinessUnitsTourOverviewPhase() && !patternInput_2[0]) && canShowCreateBusinessUnitButton) && accountSettings.BusinessUnitsEnabled;
            return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems = toList(delay(() => append_1(singleton_1(createElement(BusinessUnitsOverview, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CurrentUser: props.CurrentUser,
                Dispatch: patternInput[1],
                UserData: props.UserData,
            })), delay(() => {
                let Steps;
                return showBusinessUnitsOverviewTour ? singleton_1(createElement(TourGuide, (Steps = singleton(new TourStep("[data-test-id=\'add-new-business-units-button\']", t("onboarding.tour.business_units_overview_create_title"), reactElement("div", {
                    children: t("onboarding.tour.business_units_overview_create_content"),
                }), "bottom", true)), {
                    IsRunning: true,
                    Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                    OnFinish: () => {
                        setBusinessUnitsTourOverviewDismissed(true);
                        RouterModule_nav(ofArray(["business-units", "new" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "business-units-step"]))]), 1, 1);
                    },
                    OnSkip: () => {
                        setBusinessUnitsTourOverviewDismissed(true);
                        RouterModule_nav(singleton("business-units" + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())), 1, 1);
                    },
                    ScrollFirstStep: true,
                    Steps: Steps,
                }))) : empty_2();
            })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }
        default:
            return createElement(Skeleton, {
                Variant: "table",
            });
    }
}

